import Vue from "vue";
import VueApollo from "vue-apollo";
import fetch from "node-fetch";
import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { createUploadLink } from "apollo-upload-client";

Vue.use(VueApollo);

export default function createApollo(env) {
  const cache = new InMemoryCache();

  const getHeaders = () => {
    const headers = {};

    if (typeof window !== "undefined" && window.Vue) {
      const token = Vue.prototype.$cookie && Vue.prototype.$cookie.get("apollo_token");
      if (token) {
        headers.authorization = `Bearer ${token}`;
      }
    }

    return headers;
  };

  const defaultClient = new ApolloClient({
    link: createUploadLink({
      uri: env.APOLLO_ENDPOINT,
      fetch: fetch,
      headers: getHeaders(),
    }),
    cache,
  });

  return new VueApollo({
    defaultClient: defaultClient,
  });
}
